import { evolve } from 'rambda';
import { parseJSON } from 'date-fns';
import { PatientExaminationsDTO, mapToPatientExaminations, PatientExaminations } from './patientExaminationsDTO';

export interface PatientVisitDTO {
  createDate: string;
  id: number;
  status: string;
  executedBy?: {
    id: number | null;
    firstName: string;
    lastName: string;
    contactDetails: any[] | null;
    email: string | null;
  };
  patientId: number;
}

export interface PatientHistoryResponseDTO {
  examinations: PatientExaminationsDTO[];
  visits: PatientVisitDTO[];
}

export type PatientVisit = Omit<PatientVisitDTO, 'createDate'> & {
  createDate: Date;
};

export const mapToPatientVisit: (a: PatientVisitDTO) => PatientVisit = evolve({
  createDate: parseJSON,
});

export type PatientHistoryResponse = {
  examinations: PatientExaminations[];
  visits: PatientVisit[];
};

export const mapToPatientHistoryResponse = (dto: PatientHistoryResponseDTO): PatientHistoryResponse => ({
  examinations: dto.examinations.map(mapToPatientExaminations),
  visits: dto.visits.map(mapToPatientVisit),
});
